export default __webpack_public_path__ + "static/media/4-2_image10@2x.8a62967d.png";